import * as React from "react";
const SvgIconControlled = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 23 24", height: 91, width: 88, ...props }, /* @__PURE__ */ React.createElement("g", { style: {
  stroke: "currentColor",
  fill: "currentColor",
  strokeWidth: 427.012,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1,
  paintOrder: "normal"
}, transform: "matrix(.00155 0 0 -.00155 .35 24.8)" }, /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "currentColor",
  fill: "currentColor",
  strokeWidth: 427.012,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1,
  paintOrder: "normal"
}, d: "M6894.148 15785.034c-103-21-206-108-243-207-29-76-25-201 7-255 12-20 278-331 593-692l571-656h4839v490c0 476-1 491-21 547-27 70-99 147-155 162-32 9-5528 623-5544 620-3-1-24-5-47-9zM7069.987 12698.069c-253-255-469-478-478-497-27-54-17-142 21-182 56-60 44-59 632-59h539l6-127c30-579 268-1127 675-1554 377-397 886-653 1452-730 122-17 457-17 580 0 565 77 1063 326 1450 727 344 355 557 777 651 1285 23 121 23 144 27 862l3 737h-5096zM7370.378 8634.678c-137-18-340-69-470-118-201-75-432-209-576-332-31-26-733-654-1559-1395-826-742-1505-1348-1509-1348-5475.036-4212.287-3769.083-6414.13 634-2611 50 33 459 378 910 766l820 706 5-1547 5-1547 2773 3716c1524 2043 2772 3718 2772 3721s-831 6-1847 5c-1566-1-1865-3-1958-16z" }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "currentColor",
  fill: "currentColor",
  strokeWidth: 409.925,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1,
  paintOrder: "normal"
}, d: "M11350.925 4590.767C9759.27 2457.681 8452.731 705.708 8448.891 698.03c-6.72-10.56 525.111-12.48 3238.028-12.48h3244.749l-2.88 3319.628-1.92 3318.667-22.079 95.039c-66.239 284.155-191.997 542.391-379.194 772.788-59.519 73.919-261.116 279.355-273.596 279.355-3.84 0-1309.419-1746.212-2901.074-3880.259z" })));
export default SvgIconControlled;
